import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export type ThemePreference = 'system' | 'light' | 'dark'

interface UiState {
  theme: ThemePreference
  /** Whether the calendar's quick-access rail is expanded. */
  quickRailOpen: boolean
  /** The nav bar's "Terminanfrage erfassen" modal — a transient overlay, never persisted. */
  leadIntakeOpen: boolean

  setTheme: (theme: ThemePreference) => void
  toggleQuickRail: () => void
  openLeadIntake: () => void
  closeLeadIntake: () => void
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      theme: 'system',
      // It floats over the calendar, so it starts out of the way.
      quickRailOpen: false,
      leadIntakeOpen: false,

      setTheme: (theme) => set({ theme }),
      toggleQuickRail: () => set((state) => ({ quickRailOpen: !state.quickRailOpen })),
      openLeadIntake: () => set({ leadIntakeOpen: true }),
      closeLeadIntake: () => set({ leadIntakeOpen: false }),
    }),
    {
      name: 'ail.ui',
      version: 1,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ theme: state.theme, quickRailOpen: state.quickRailOpen }),
    },
  ),
)

export const useTheme = () => useUiStore((state) => state.theme)
export const useQuickRailOpen = () => useUiStore((state) => state.quickRailOpen)
export const useLeadIntakeOpen = () => useUiStore((state) => state.leadIntakeOpen)
